import classNames from 'classnames';
import { IKilometersStat, IRunsStat, OpenFlag } from 'api/resort/types';
import { useDistanceFormatter } from 'i18n/unitFormat';
import { showKilometres } from 'util/showKilometres';

import { useOTSTranslation } from 'i18n/useOTSTranslation';
import cellStyles from './styles.module.scss';

interface IOpenTrailsCellProps {
  openFlag?: OpenFlag
  kilometres?: IKilometersStat
  runs?: IRunsStat
  noValue: string
}

const OpenTrailsCell = ({
  openFlag, kilometres, runs, noValue,
}: IOpenTrailsCellProps) => {
  const { t } = useOTSTranslation('common');
  const distanceFormatter = useDistanceFormatter('kmOrMile');
  const isTemporaryAwailable = openFlag !== OpenFlag.TemporarilyClosed && openFlag !== OpenFlag.NoReportAvailable;
  let value = noValue;

  if (isTemporaryAwailable && showKilometres) {
    value = distanceFormatter(
      [kilometres?.open, kilometres?.total],
      '/',
      undefined,
      false,
      false,
      t('common.dash'),
    );
  }

  if (isTemporaryAwailable && !showKilometres) {
    value = `${runs?.open ?? t('common.dash')}/${runs?.total ?? t('common.dash')}`;
  }

  if (isTemporaryAwailable && showKilometres && (!kilometres?.open && !kilometres?.total)) {
    value = `${runs?.open ?? t('common.dash')}/${runs?.total ?? t('common.dash')}`;
  }

  if (openFlag === OpenFlag.Closed) {
    value = noValue;
  }

  const kilometersOpen = !!kilometres?.open && !!kilometres.total && Number.parseInt(`${(kilometres.open / kilometres.total) * 100}`, 10);

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      {value}
      <div className={classNames(cellStyles.small, cellStyles.openTrailsCell)}>
        {showKilometres && isTemporaryAwailable && kilometersOpen
          && `${kilometersOpen}${t('region.skiReport.percentageOpen')}`}
        {runs?.openPercent && isTemporaryAwailable && !showKilometres
          ? `${runs?.openPercent}${t('region.skiReport.percentageOpen')}`
          : <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>}
      </div>
    </span>
  );
};

export default OpenTrailsCell;
